export const colors = {
  bg: '#f4f1ee',
  bgAlt: '#f9f8f8',
  white: '#ffffff',
  text: '#1a1615',
  textSecondary: '#453f3d',
  textMuted: '#757170',
  border: '#e4e2e2',
  brown: '#614a44',
  blue: '#84b9ef',
  blueDark: '#156cc2',
  blueLight: '#9cc1e7',
  bluePale: '#e2ecf5',
  warm: '#f4e6da',
  warmAlt: '#f0eae5',
  warmDeep: '#eddfd0',
  green: '#0ea158',
  greenPale: '#eaf3ed',
};

export const heroGradient =
  'linear-gradient(180deg, #9ec6ee 0%, #aacff1 22%, #bedbf3 46%, #cfe0f1 68%, #dde9f4 100%)';

export const sectionGradient =
  'linear-gradient(180deg, rgb(183, 213, 241) 15%, rgb(244, 230, 218) 100%)';

export const fonts = {
  body: "'Inter', 'Helvetica Neue', Helvetica, Arial, system-ui, sans-serif",
  mono: "'Fragment Mono', 'SF Mono', Menlo, monospace",
};

export const breakpoints = {
  mobile: '809px',
  tablet: '1199px',
};
